const randomize = require("randomatic");

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "name_contains",
      label: "Name",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "department_contains",
      label: "Department",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "brand_contains",
      label: "Brand",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/DestinationFilter"),
    props: {
      filterName: "destinationId",
      label: "Destination",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/DateFilter"),
    props: {
      filterName: "validFrom_gte",
      label: "Valid From (from)",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/DateFilter"),
    props: {
      filterName: "validFrom_lte",
      label: "Valid From (to)",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/DateFilter"),
    props: {
      filterName: "validTo_gte",
      label: "Valid To (from)",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/DateFilter"),
    props: {
      filterName: "validTo_lte",
      label: "Valid To (to)",
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/open-groups/open-group-filters.js